
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 25","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.281 14.45a.75.75 0 10-.562-1.39l.562 1.39zm-18-1.39a.75.75 0 00-.562 1.39l.562-1.39zM15.25 6.5a.75.75 0 001.5 0h-1.5zm-8 0a.75.75 0 001.5 0h-1.5zM12 11.75a.75.75 0 000 1.5v-1.5zm.01 1.5a.75.75 0 000-1.5v1.5zM5 7.25h14v-1.5H5v1.5zM20.25 8.5v10h1.5v-10h-1.5zM19 19.75H5v1.5h14v-1.5zM3.75 18.5v-10h-1.5v10h1.5zM5 19.75c-.69 0-1.25-.56-1.25-1.25h-1.5A2.75 2.75 0 005 21.25v-1.5zm15.25-1.25c0 .69-.56 1.25-1.25 1.25v1.5a2.75 2.75 0 002.75-2.75h-1.5zM19 7.25c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0019 5.75v1.5zM5 5.75A2.75 2.75 0 002.25 8.5h1.5c0-.69.56-1.25 1.25-1.25v-1.5zm15.719 7.31A23.182 23.182 0 0112 14.75v1.5c3.28 0 6.414-.639 9.281-1.8l-.562-1.39zM12 14.75c-3.085 0-6.027-.6-8.719-1.69l-.562 1.39c2.867 1.161 6 1.8 9.281 1.8v-1.5zm-2-11.5h4v-1.5h-4v1.5zm5.25 1.25v2h1.5v-2h-1.5zm-6.5 2v-2h-1.5v2h1.5zM14 3.25c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0014 1.75v1.5zm-4-1.5A2.75 2.75 0 007.25 4.5h1.5c0-.69.56-1.25 1.25-1.25v-1.5zm2 11.5h.01v-1.5H12v1.5z"}})])
          )
        }
      }
    